import React, { FC, PropsWithChildren } from "react";
import Head from "next/head";
import Script from "next/script";

interface Props {
  title?: string;
  description?: string;
  image?: string;
  noindex?: boolean;
}

export const HeadMeta: FC<PropsWithChildren<Props>> = ({
  title,
  description,
  image,
  noindex,
}) => {
  const metaTitle =
    title || "Cross-Border Processing for Banks | Payall Payment Systems";
  const metaDescription =
    description ||
    "A new Cross Border Processor offering Correspondent Banking as a Service and enabling 24x7 Instant Cross Border Payments";
  const metaImage = image || "/thumbnail.png";

  return (
    <>
      <Head>
        <link rel="icon" href="/favicon.ico" />
        {noindex && <meta name="robots" content="noindex, nofollow" />}
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content={metaImage} />
        <meta property="og:url" content="https://payall.com/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@payallps" />
        <meta name="twitter:creator" content="@payallps" />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content={metaImage} />
      </Head>
      {/* Analytics/marketing scripts are render-irrelevant, so they load
          via next/script instead of competing with page resources in
          <head>. GA starts once the page is interactive; the HubSpot suite
          (~90 KiB + 4 follow-up scripts) waits until the browser is idle
          after `load`. dataLayer is stubbed inline, so events fired before
          gtag.js arrives are queued, not lost. */}
      <Script
        id="gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-M1B9MBTV2M');
        `,
        }}
      />
      <Script
        strategy="afterInteractive"
        src="https://www.googletagmanager.com/gtag/js?id=G-M1B9MBTV2M"
      />
      <Script
        id="hs-script-loader"
        strategy="lazyOnload"
        src="https://js.hs-scripts.com/4785555.js"
      />
    </>
  );
};
